<cv-tab-group>
	<cv-tab [active]="true" [title]="'Request'">
		<cv-collapse>
			<cv-panel   [class]="'dark'" [isExpandable]="false" [rightButtons]="copyRequest">
				<ace-editor
					#markupEditor
					[(text)]="requestInformation"
					[readOnly]="true"
					[mode]="'json'"					
					[ngStyle]="{
						height:'500px',
						width: '100%'
					}"
				>
				</ace-editor>
			</cv-panel>
		</cv-collapse>
	</cv-tab>
</cv-tab-group>
